import { resizeObserver } from '../utils/dom';
import Component from './component';

export default class Marquee extends Component {
  constructor (props) {
    super(props);
    this.$content = null;
    this.onresize = this.onresize.bind(this);
  }

  getDefaultProps () {
    return {
      duration: '5s',
      started: true,
      pauseOnHover: false,
      loop: -1
    };
  }

  attach (element) {
    super.attach(element);
    this.$content = this.$('.iono-marquee-content');
    resizeObserver.observe(this.$element);
    this.$element.addEventListener('resize', this.onresize);
    this.update();
  }

  detach () {
    if (this.isAttached()) {
      this.$element.removeEventListener('resize', this.onresize);
      resizeObserver.unobserve(this.$element);
      this.$content = null;
    }
    super.detach();
  }

  start () {
    this.setProps({
      started: true
    });
  }

  stop () {
    this.setProps({
      started: false
    });
  }

  update () {
    if (this.props.pauseOnHover) {
      this.$element.classList.add('iono-marquee--pause-on-hover');
    } else {
      this.$element.classList.remove('iono-marquee--pause-on-hover');
    }

    if (this.props.started) {
      this.$element.classList.add('iono-animated');
    } else {
      this.$element.classList.remove('iono-animated');
    }
  }

  render () {
    return `
      <div class="iono-marquee ${this.props.autostart ? 'iono-animated' : ''}">
        <div class="iono-marquee-content"></div>
      </div>
    `;
  }

  onresize (event) {
    this.stop();

    if (Math.round(event.detail.contentRect.width) < this.$element.scrollWidth) {
      this.start();
    } else {
      this.stop();
    }
  }
}
